import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = (process.env.REACT_APP_API_BASE || '').replace(/\/api$/, '') || (window.location.protocol === 'https:' ? '' : `http://${window.location.hostname}:5000`);

const SAMPLE_JSON = JSON.stringify({
  version: '3.1',
  screens: [
    {
      id: 'APPOINTMENT',
      title: 'Book Appointment',
      terminal: true,
      layout: {
        type: 'SingleColumnLayout',
        children: [
          { type: 'TextHeading', text: 'Select slot' },
          { type: 'DatePicker', name: 'date', label: 'Preferred date', required: true },
          { type: 'Dropdown', name: 'slot', label: 'Time slot', required: true,
            'data-source': [
              { id: 'morning', title: 'Morning (10-1pm)' },
              { id: 'evening', title: 'Evening (5-9pm)' }
            ] },
          { type: 'Footer', label: 'Book', 'on-click-action': { name: 'complete', payload: {} } }
        ]
      }
    }
  ]
}, null, 2);

export default function WhatsAppInteractiveFlowsPage() {
  const [flows, setFlows] = useState([]);
  const [editing, setEditing] = useState(null);
  const headers = { Authorization: `Bearer ${localStorage.getItem('dentalToken')}` };

  const load = async () => {
    try { const { data } = await axios.get(`${API}/api/saas/wa-interactive-flows`, { headers }); setFlows(data); }
    catch (err) { console.error(err); }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editing._id) await axios.patch(`${API}/api/saas/wa-interactive-flows/${editing._id}`, editing, { headers });
      else await axios.post(`${API}/api/saas/wa-interactive-flows`, editing, { headers });
      setEditing(null); load();
    } catch (err) { alert(err.response?.data?.error || 'Failed'); }
  };

  const publish = async (id) => {
    if (!window.confirm('Publish flow to Meta? (Currently stubbed — real API call would go here)')) return;
    await axios.post(`${API}/api/saas/wa-interactive-flows/${id}/publish`, {}, { headers });
    load();
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this flow?')) return;
    await axios.delete(`${API}/api/saas/wa-interactive-flows/${id}`, { headers });
    load();
  };

  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>⚡ WhatsApp Interactive Flows</h2>
        <button onClick={() => setEditing({ name: '', category: 'APPOINTMENT_BOOKING', flowJson: SAMPLE_JSON, description: '' })} style={btnPrimary}>+ New Interactive Flow</button>
      </div>

      <div style={{ background: '#eff6ff', padding: 12, borderRadius: 6, marginBottom: 16, fontSize: 13 }}>
        💡 Meta WhatsApp Flows = native rich experiences (forms, pickers, buttons) inside chat. Upload the Meta-spec JSON and publish via Meta Business API.
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
        {flows.map(f => (
          <div key={f._id} style={card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <strong>{f.name}</strong>
              <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 12,
                background: f.status === 'published' ? '#10b981' : f.status === 'draft' ? '#f59e0b' : '#888',
                color: 'white' }}>{f.status}</span>
            </div>
            <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>{f.category}</div>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>{f.description || 'No description'}</div>
            {f.metaFlowId && <div style={{ fontSize: 11, color: '#888', marginBottom: 8 }}>Meta ID: {f.metaFlowId}</div>}
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={() => setEditing(f)} style={miniBtn}>Edit</button>
              {f.status === 'draft' && <button onClick={() => publish(f._id)} style={{ ...miniBtn, background: '#10b981', color: 'white' }}>📤 Publish</button>}
              <button onClick={() => remove(f._id)} style={{ ...miniBtn, color: '#ef4444' }}>Delete</button>
            </div>
          </div>
        ))}
        {flows.length === 0 && <div style={{ gridColumn: '1/-1', textAlign: 'center', color: '#888', padding: 40 }}>No interactive flows yet</div>}
      </div>

      {editing && (
        <Modal onClose={() => setEditing(null)} title={editing._id ? 'Edit Interactive Flow' : 'New Interactive Flow'}>
          <input placeholder="Flow name" value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })} style={input} />
          <select value={editing.category} onChange={e => setEditing({ ...editing, category: e.target.value })} style={input}>
            <option>APPOINTMENT_BOOKING</option><option>LEAD_GENERATION</option><option>CUSTOMER_SUPPORT</option>
            <option>SURVEY</option><option>SIGN_UP</option><option>CONTACT_US</option><option>OTHER</option>
          </select>
          <textarea placeholder="Description" value={editing.description || ''} onChange={e => setEditing({ ...editing, description: e.target.value })} style={{ ...input, minHeight: 60 }} />
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Flow JSON (Meta spec):</div>
          <textarea
            value={typeof editing.flowJson === 'string' ? editing.flowJson : JSON.stringify(editing.flowJson, null, 2)}
            onChange={e => setEditing({ ...editing, flowJson: e.target.value })}
            style={{ ...input, minHeight: 300, fontFamily: 'monospace', fontSize: 12 }}
          />
          <button onClick={save} style={btnPrimary}>Save</button>
        </Modal>
      )}
    </div>
  );
}

function Modal({ children, onClose, title }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'white', borderRadius: 8, padding: 24, width: '90%', maxWidth: 700, maxHeight: '90vh', overflow: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <h3 style={{ margin: 0 }}>{title}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

const input = { padding: 8, border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, marginBottom: 8, width: '100%', boxSizing: 'border-box' };
const btnPrimary = { padding: '8px 16px', background: '#25D366', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 };
const miniBtn = { padding: '4px 10px', fontSize: 12, background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 4, cursor: 'pointer' };
const card = { background: 'white', padding: 16, borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' };
